import { render, staticRenderFns } from "./preview-document-dialog.component.vue?vue&type=template&id=5b59b61a"
import script from "./preview-document-dialog.component.ts?vue&type=script&lang=ts&external"
export * from "./preview-document-dialog.component.ts?vue&type=script&lang=ts&external"
import style0 from "./preview-document-dialog.component.vue?vue&type=style&index=0&id=5b59b61a&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b59b61a')) {
      api.createRecord('5b59b61a', component.options)
    } else {
      api.reload('5b59b61a', component.options)
    }
    module.hot.accept("./preview-document-dialog.component.vue?vue&type=template&id=5b59b61a", function () {
      api.rerender('5b59b61a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shared/preview-document-dialog/preview-document-dialog.component.vue"
export default component.exports